/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  StorageBody,
} from '../models/index';
import {
    StorageBodyFromJSON,
    StorageBodyToJSON,
} from '../models/index';

export interface ApiStorageCheckinPostRequest {
    storageBody: StorageBody;
}

export interface ApiStorageCheckoutPostRequest {
    storageBody: StorageBody;
}

/**
 * 
 */
export class StorageApi extends runtime.BaseAPI {

    /**
     */
    async apiStorageCheckinPostRaw(requestParameters: ApiStorageCheckinPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['storageBody'] == null) {
            throw new runtime.RequiredError(
                'storageBody',
                'Required parameter "storageBody" was null or undefined when calling apiStorageCheckinPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/storage/checkin`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StorageBodyToJSON(requestParameters['storageBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStorageCheckinPost(requestParameters: ApiStorageCheckinPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStorageCheckinPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStorageCheckoutPostRaw(requestParameters: ApiStorageCheckoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['storageBody'] == null) {
            throw new runtime.RequiredError(
                'storageBody',
                'Required parameter "storageBody" was null or undefined when calling apiStorageCheckoutPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/storage/checkout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StorageBodyToJSON(requestParameters['storageBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStorageCheckoutPost(requestParameters: ApiStorageCheckoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStorageCheckoutPostRaw(requestParameters, initOverrides);
    }

}
